export function $(el) {
  return document.getElementById(el.split('#')[1])
}

function initWebSocket(options) { // 初始化weosocket
  // const wsuri = 'ws://10.10.52.140:9055/physician/166723db127042dbad42a012513a36f9'
  // 连接服务端
  const websock = new WebSocket(options.url)
  // 指定事件回调
  websock.onmessage = options.onmessage // 数据接收
  websock.onopen = options.onopen // 打开
  websock.onerror = options.onerror // 连接失败
  websock.onclose = options.onclose // 关闭连接
}
// 门店端向医生端推送
export function noticePatient2Pharmacist(options) {
  options = Object.assign({}, options, {
    url: process.env.VUE_APP_WEBSOCKET_URL + options.url
  })
  initWebSocket(options)
}
// 医生端向门店端推送
export function noticePharmacist2Patient(options) {
  options = Object.assign({}, options, {
    url: process.env.VUE_APP_WEBSOCKET_URL + options.url
  })
  initWebSocket(options)
}
